// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Fmd4ZDqJu7rPlxO","icon":"_31AJtVgg0IQYd_pg"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/honest_work/components/Approval/Approval.css
// module id = 124
// module chunks = 1 4